<template>
<!--  <div>-->
<!--    <v-btn-->
<!--    fab-->
<!--    dark-->
<!--    fixed-->
<!--    bottom-->
<!--    right-->
<!--    color="primary"-->
<!--    style="bottom: 120px;"-->
<!--    @click="qie"-->
<!--  >-->
<!--    <v-icon>fa:fas fa-circle-notch fa-spin</v-icon>-->
<!--  </v-btn>-->
<!--  <v-btn-->
<!--    fab-->
<!--    dark-->
<!--    fixed-->
<!--    bottom-->
<!--    right-->
<!--    color="primary"-->
<!--    style="bottom: 60px;"-->
<!--    @click="goBack"-->
<!--  >-->
<!--    <v-icon>mdi-arrow-left</v-icon>-->
<!--  </v-btn>-->
<!--    <v-dialog v-model="internal" scrollable  max-width="600px">-->
<!--      <v-card>-->
<!--        <v-card-title>是否切换{{ tabName }}</v-card-title>-->
<!--        <v-card-actions>-->
<!--          <v-btn color="green darken-1" text @click="internal = false">-->
<!--            取消-->
<!--          </v-btn>-->
<!--          <v-btn color="green darken-1" text @click="submit">提交</v-btn>-->
<!--        </v-card-actions>-->
<!--      </v-card>-->
<!--    </v-dialog>-->
<!--  </div>-->

</template>

<script>
import {setUrl,getUrl} from '../utils/baseurl'
export default {
  data(){
    return {
      tabName:"内网",
      internal:false
    }
  },
  methods: {
    qie(){
      // if (getUrl() == process.env.EXTERNAL_URL) {
      //   this.tabName = "内网"
      // }else{
      //   this.tabName = "外网"
      // }
      this.internal = true
    },
    goBack () {
      //this.$router.go(-1) 或者 window.history.back()
      this.$router.back()
    },
    submit(){
      if (getUrl() == process.env.INTERNAL_URL) {
        setUrl(process.env.EXTERNAL_URL)
      }else{
        setUrl(process.env.INTERNAL_URL)
      }
      this.internal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FloatingButton.vue